// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.spectator-controls {
  position: absolute;
  top: 81%; 
  width: 80%;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  z-index: 1021;
  left: 10%; /* Центрирование блока */
  margin: 5px;
}

.spectator-text {
  font-size: 1.2em; /* Увеличение размера текста */
  color: var(--tg-theme-text-color); /* Темный цвет текста для лучшей читаемости */
  margin-bottom: 10px; /* Отступ снизу для разделения текста и кнопки */
  text-align: center;
}

.spectator-button {
  background-color: var(--tg-theme-button-color); 
  color: var(--tg-theme-button-text-color);
  font-size: 16px;
  
  width: 200px; 
  padding: 11px 18px; /* Паддинг для увеличения размера кнопки */
  border: none;
  border-radius: 12px;
  cursor: pointer; 
  transition: background-color 0.3s; /* Плавное изменение фона при наведении */
  margin: 5px;

}`, "",{"version":3,"sources":["webpack://./src/components/board/Spectator.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,SAAS,EAAE,wBAAwB;EACnC,WAAW;AACb;;AAEA;EACE,gBAAgB,EAAE,8BAA8B;EAChD,iCAAiC,EAAE,6CAA6C;EAChF,mBAAmB,EAAE,gDAAgD;EACrE,kBAAkB;AACpB;;AAEA;EACE,8CAA8C;EAC9C,wCAAwC;EACxC,eAAe;;EAEf,YAAY;EACZ,kBAAkB,EAAE,0CAA0C;EAC9D,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,iCAAiC,EAAE,yCAAyC;EAC5E,WAAW;;AAEb","sourcesContent":[".spectator-controls {\n  position: absolute;\n  top: 81%; \n  width: 80%;\n  justify-content: center;\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  z-index: 1021;\n  left: 10%; /* Центрирование блока */\n  margin: 5px;\n}\n\n.spectator-text {\n  font-size: 1.2em; /* Увеличение размера текста */\n  color: var(--tg-theme-text-color); /* Темный цвет текста для лучшей читаемости */\n  margin-bottom: 10px; /* Отступ снизу для разделения текста и кнопки */\n  text-align: center;\n}\n\n.spectator-button {\n  background-color: var(--tg-theme-button-color); \n  color: var(--tg-theme-button-text-color);\n  font-size: 16px;\n  \n  width: 200px; \n  padding: 11px 18px; /* Паддинг для увеличения размера кнопки */\n  border: none;\n  border-radius: 12px;\n  cursor: pointer; \n  transition: background-color 0.3s; /* Плавное изменение фона при наведении */\n  margin: 5px;\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
